var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "no-padding", attrs: { name: "contact-person" } },
    [
      _c(
        "q-scroll-area",
        {
          staticClass: "full-width customer-card__tab-scroll",
          attrs: {
            "thumb-style": {
              width: "5px",
              "background-color": "#555",
              opacity: 1
            }
          }
        },
        [
          _vm.customer.contact_persons &&
          _vm.customer.contact_persons.data &&
          _vm.customer.contact_persons.data.length > 0
            ? [
                _c(
                  "div",
                  {
                    directives: [{ name: "is-user", rawName: "v-is-user" }],
                    staticClass:
                      "row sticky-top bg-white q-px-md q-py-sm border-bottom customer-card__toolbar"
                  },
                  [
                    _c("q-btn", {
                      attrs: {
                        label: _vm.$tc("contact_person", 1),
                        icon: "add",
                        color: "gray",
                        flat: ""
                      },
                      on: { click: _vm.handleCreateContactPerson }
                    })
                  ],
                  1
                ),
                _c("q-table", {
                  staticClass: "no-shadow",
                  attrs: {
                    "row-key": "id",
                    columns: _vm.tableColumns,
                    data: _vm.mappedContactPersons,
                    "hide-header": "",
                    "hide-bottom": "",
                    "binary-state-sort": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "body-cell-actions",
                      fn: function(props) {
                        return _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  icon: "more_vert",
                                  color: "grey-7",
                                  flat: "",
                                  round: "",
                                  dense: ""
                                }
                              },
                              [
                                _c(
                                  "q-popover",
                                  [
                                    _c(
                                      "q-list",
                                      {
                                        staticClass: "no-border",
                                        attrs: { link: "" }
                                      },
                                      [
                                        _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.handleUpdate(props.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-side", {
                                              attrs: { icon: "edit" }
                                            }),
                                            _c("q-item-main", {
                                              attrs: { label: _vm.$t("edit") }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.handleDelete(props.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-side", {
                                              attrs: { icon: "delete" }
                                            }),
                                            _c("q-item-main", {
                                              attrs: { label: _vm.$t("delete") }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ])
                })
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-center justify-center items-center col-grow q-pt-lg"
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("assets/emptystates/contacts_empty.svg"),
                        height: "100px"
                      }
                    }),
                    _c("h6", { staticClass: "q-my-md text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("no_contact_person")))
                    ]),
                    _c(
                      "q-btn",
                      {
                        staticClass: "q-mt-lg",
                        attrs: { color: "primary", outline: "" },
                        on: { click: _vm.handleCreateContactPerson }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("create_contact_person")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _c(
        "default-modal",
        {
          attrs: {
            name: "add-customer-modal",
            autofocus: _vm.$refs.addCustomerForm,
            successHandler: _vm.handleSaveCustomer,
            title: _vm.$t("create_contact_person"),
            width: "sm"
          },
          model: {
            value: _vm.modalOpened,
            callback: function($$v) {
              _vm.modalOpened = $$v
            },
            expression: "modalOpened"
          }
        },
        [
          _c("add-contact-person-form", {
            ref: "addCustomerForm",
            attrs: { slot: "content", action: _vm.action },
            slot: "content",
            model: {
              value: _vm.formData,
              callback: function($$v) {
                _vm.formData = $$v
              },
              expression: "formData"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }